import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const CancelCircle = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334Zm2.412 5.19a.667.667 0 0 0-.998-.88L12 11.057l-1.414-1.414-.063-.055a.667.667 0 0 0-.88.998L11.057 12l-1.414 1.414-.055.063a.667.667 0 0 0 .998.88L12 12.943l1.414 1.414.063.055a.667.667 0 0 0 .88-.998L12.943 12l1.414-1.414.055-.063Z"
            : "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm11.138 3.138a.666.666 0 0 0 0-.943L12.943 12l2.195-2.195a.666.666 0 1 0-.943-.943L12 11.057 9.805 8.862a.666.666 0 1 0-.943.943L11.057 12l-2.195 2.195a.666.666 0 1 0 .943.943L12 12.943l2.195 2.195a.665.665 0 0 0 .943 0Z"
        }
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};

export { CancelCircle };
